import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/app/bridge-resource-guide/components/BridgeRGHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/JourneyNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69adfd40886e10001451db07/haalproject/src/components/NextBridgeCTA.tsx");
